import React from "react";
import { useParams } from "wouter";

import { useQueryState } from "../../../../components/src/use-query-state";

import { PreTrade } from "./PreTrade";
import { PmSelectPrompt } from "./PmSelectPrompt";

export interface Props {
    lookThrough: boolean;
}

export const PreTradeView = (props: Props): React.ReactElement => {
    const [endDate] = useQueryState("endDate", new Date().toISOString().slice(0, 10));
    const { id } = useParams<{ id: string }>();

    if (typeof id === "undefined" || id === "all") {
        return <PmSelectPrompt message="Select a client" />;
    }
    return (
        <div>
            <PreTrade clientIds={[id]} endDate={endDate} lookThrough={props.lookThrough} />
        </div>
    );
};
